var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreIconBarNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 7C3 6.44772 3.44772 6 4 6H26C26.5523 6 27 6.44772 27 7C27 7.55228 26.5523 8 26 8H4C3.44772 8 3 7.55228 3 7Z",
    fill: "#212338"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 15C3 14.4477 3.44772 14 4 14H26C26.5523 14 27 14.4477 27 15C27 15.5523 26.5523 16 26 16H4C3.44772 16 3 15.5523 3 15Z",
    fill: "#212338"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 23C3 22.4477 3.44772 22 4 22H26C26.5523 22 27 22.4477 27 23C27 23.5523 26.5523 24 26 24H4C3.44772 24 3 23.5523 3 23Z",
    fill: "#212338"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 7C3 6.44772 3.44772 6 4 6H26C26.5523 6 27 6.44772 27 7C27 7.55228 26.5523 8 26 8H4C3.44772 8 3 7.55228 3 7Z",
    stroke: "#212338",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 15C3 14.4477 3.44772 14 4 14H26C26.5523 14 27 14.4477 27 15C27 15.5523 26.5523 16 26 16H4C3.44772 16 3 15.5523 3 15Z",
    stroke: "#212338",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3 23C3 22.4477 3.44772 22 4 22H26C26.5523 22 27 22.4477 27 23C27 23.5523 26.5523 24 26 24H4C3.44772 24 3 23.5523 3 23Z",
    stroke: "#212338",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreIconBarNew);
export default __webpack_public_path__ + "static/media/more-icon-bar-new.18dfdb026f3773313e5a44bce531d815.svg";
export { ForwardRef as ReactComponent };